<template>
  <div id="login" style="text-align:center !important">
    <!-- 用户登录 -->
    <!-- <span class="loginj">

    </span> -->
    <div class="logincenter" style="text-align:center !important">

      <div style="text-align:center !important">
        <div class="login-form" style="text-align:center !important">
          <div class="filed left">
            <router-link :to="{path:'/exhibition/login/ch/Administrator'}"><i class="iconfont icon-yonghu icou"></i></router-link>
            <span class="formTitleStyle">用户登录</span>
            <!-- <span class="signstyle">没有账户?<router-link :to="{path:'/exhibition/login/ch/Register'}"><a>去注册</a></router-link></span> -->
            <span class="signstyle">没有账户?<a @click="qyjbxxShow = true">去注册</a></span>
          </div>
          <el-form ref="loginForm" id="loginForm" autocomplete="off" name="loginform" method="post">
            <div class="filed">
              <el-input placeholder="手机号" v-model="username" prefix-icon="iconfont icon-login-username" @blur="mobileCheck"
                class="iconStyle"></el-input>
              <p class="alert" v-show="usernameAlertFlag">*请输入正确手机号</p>
            </div>
            <div class="filed">
              <el-input placeholder="密码" v-model="password" prefix-icon="iconfont icon-login-password" type="password"
                @blur="passwordCheck"></el-input>
              <p class="alert1" v-show="passwordAlertFlag">*请输入密码</p>
            </div>
            <div class="filed">
              <el-input placeholder="验证码" class="yanzhengma_input" v-model="picLyanzhengma" prefix-icon="iconfont icon-login-validate"
                @blur="validateCheck" @keyup.enter.native="login"></el-input>
              <input type="button" class="verification1 bk" id="code" @click="createCode" v-model="checkCode" />
              <p class="alert2" v-show="validateAlertFlag">*验证码错误</p>
            </div>
            <div class="filed right">
              <span class="muchtab">
                <!-- <router-link :to="{path:'/exhibition/login/ch/ForgetUsername'}"><a>忘记用户名</a></router-link> | -->
                <a class="lanb" style="color:blue" href="/static/templates/帮助手册.doc">注册指南</a> |
                <router-link :to="{path:'/exhibition/login/ch/LoginByMessage'}"><a>短信验证码登录</a></router-link> |
                <router-link :to="{path:'/exhibition/login/ch/ForgetPassword'}"><a>忘记密码</a></router-link> |
                <router-link :to="{path:'/exhibition/login/ch/Reset'}"><a>重置账户</a></router-link>
              </span>
            </div>
            <div class="filed lgin">
              <el-button type="danger" @click="login" round>登录</el-button>
            </div>
          </el-form>
        </div>
      </div>

    </div>

    <el-dialog width="75%" title="请填写企业基本信息完成注册" :visible.sync="qyjbxxShow" :close-on-click-modal="false" :append-to-body="true" @close="closeRegisterDialog()">
      <registerBaseInfo ref="registerBaseInfo" @close="closeRegisterDialog"></registerBaseInfo>
    </el-dialog>
  </div>
</template>

<script>
//引入
import registerBaseInfo from '@/views/exhibition/prediction/exhprediction/exhpredictionEdit/RegisterBaseInfo'
  var code; //在全局定义验证码
  import {Encrypt,Decrypt} from '@/common/js/secret.js'
  export default {
    components: {
      registerBaseInfo
    },
    name: 'Login',
    data() {
      return {
        username: "",
        password: "",
        picLyanzhengma: '',
        checkCode: '',
        // 校验标识符
        usernameAlertFlag: false,
        passwordAlertFlag: false,
        validateAlertFlag: false,
        captcha1 : {},
        isTCaptchaPass: false,
        isTCaptchaPass: false,
        qyjbxxShow: false,
      }
    },
    created() {
      var vm = this;
      // 已登录用户访问登录页时按角色跳转首页；但需先校验 token 是否仍有效，
      // 避免过期 token 盲目跳首页后接口返回 44444444 又被弹回登录（2026-09-28 修复）
      if (localStorage.isLogin === 'TRUE') {
        var currentUser = JSON.parse(localStorage.getItem('CURRENTUSER') || '{}');
        vm.$axios.get('/organization/getOrgAndUserList').then(function () {
          if (currentUser.deptid == 'ZSYH') {
            vm.$router.replace({ path: '/exhibitor/home' });
          } else {
            vm.$router.replace({ path: '/index' });
          }
        }).catch(function () {
          // token 失效：清除残留登录态，停留在登录页
          localStorage.removeItem('isLogin');
          localStorage.removeItem('XTOKEN');
          localStorage.removeItem('CURRENTUSER');
        });
        return;
      }
      this.createCode();
      var type = this.$route.query.type;
      if (type == 'register' || type == 'forgetUsername' || type == 'forgetPassword') {
        this.username = this.$route.query.username;
        this.password = this.$route.query.password;
      }
      
      this.captcha1 = new TencentCaptcha('2053908635', function(res) {
        if(res.ret === 0){
          vm.isTCaptchaPass = true;
          vm.login(res);
        }
      });
    },
    methods: {
      // 验证用户名是否为手机号
      mobileCheck() {
        if (!/^1[3456789]\d{9}$/.test(this.username)) {
          //用户名不正确，显示红字提醒
          this.usernameAlertFlag = true;
          return false;
        } else {
          this.usernameAlertFlag = false;
          return true;
        }
      },
      //密码校验
      passwordCheck() {
        //密码为空
        if (this.password == '' || this.password == null) {
          this.passwordAlertFlag = true;
          return false;
        } else {
          this.passwordAlertFlag = false;
          return true;
        }
      },
      //验证码校验
      validateCheck() {
        //验证码错误
        if (this.picLyanzhengma.toUpperCase() != this.checkCode) {
          this.validateAlertFlag = true;
          //刷新Verification Code
          this.createCode();
          this.picLyanzhengma = '';
          return false;
        } else {
          //清空所有红字提醒
          this.validateAlertFlag = false;
          return true;
        }
      },
      // 图片验证码
      createCode() {
        code = "";
        var codeLength = 4; //验证码的长度
        var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
          'M', 'N', 'O', 'P', 'Q', 'R',
          'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'); //随机数
        for (var i = 0; i < codeLength; i++) { //循环操作
          var index = Math.floor(Math.random() * 36); //取得随机数的索引（0~35）
          code += random[index]; //根据索引取得随机数加到code上
        }
        this.checkCode = code; //把code值赋给验证码
      },
      // 失焦验证图和密码
      checkLpicma() {
        this.picLyanzhengma.toUpperCase(); //取得输入的验证码并转化为大写
        if (this.picLyanzhengma == '') {
          // $(".login_content1 span:eq(2)").text("请输入验证码")
          // $(".login_content1 span:eq(2)").removeClass("disappear");
        } else if (this.picLyanzhengma.toUpperCase() != this.checkCode) { //若输入的验证码与产生的验证码不一致时
          alert("验证码错误！")
          // $(".login_content1 span:eq(2)").removeClass("disappear");
          this.createCode(); //刷新验证码
          this.picLyanzhengma = '';
        } else { //输入正确时
          // $(".login_content1 span:eq(2)").addClass("disappear");
          // $(".login_content1 span:eq(2)").text("请输入验证码")
          return true;
        }

      },
      //登录
      login(res) {
        let vm = this;
        //校验
        if (!/^1[3456789]\d{9}$/.test(vm.username)) {
          vm.usernameAlertFlag = true;
        } else if (vm.password == '' || vm.password == null) {
          vm.passwordAlertFlag = true;
        } else if (vm.picLyanzhengma.toUpperCase() != vm.checkCode) {
          vm.validateAlertFlag = true;
          //刷新Verification Code
          vm.createCode();
          vm.picLyanzhengma = '';
        } else {
          if(this.isTCaptchaPass == false){
            this.captcha1.show();
            return
          }
          var params = {
            accountVO:{
              username: vm.username,
              password: Encrypt(vm.password),
              usertype: "CHN",
              deptid: "ZSYH"
            },
            dcrq:{
              randstr: res.randstr,
              ticket : res.ticket,
            }
          }
          vm.$axios.post('/login', params).then(function(res) {
            if (res.data.code == '00000000') {
              localStorage.removeItem('isLogin');
              localStorage.removeItem('XTOKEN');
              localStorage.removeItem('CURRENTUSER');
              localStorage.setItem('isLogin', 'TRUE');
              localStorage.setItem('XTOKEN', res.data.result.token);
              localStorage.setItem('CURRENTUSER', JSON.stringify(res.data.result.currentUser));
              localStorage.setItem('module', 'ZSYH');
              // 重置菜单权限集合缓存，避免同页面重登/清缓存后用上一次会话的内存旧值误判（2026-09-16 修复）
              this.$store.commit('SET_MENU_PATHS', []);
              this.$store.commit('SET_MENU_READY', false);
              var menuVm = this;
              menuVm.$axios.get('/resource/menuTree/' + localStorage.getItem('module')).then(function (res) {
                var paths = [];
                (function collect(list) {
                  (list || []).forEach(function (m) {
                    if (m.resourcename) paths.push(m.resourcename);
                    if (m.children) collect(m.children);
                  });
                })(res.data.result);
                menuVm.$store.commit('SET_MENU_PATHS', paths);
                menuVm.$store.commit('SET_MENU_READY', true);
              });
              this.CONSTANT.currentUser = res.data.result.currentUser;
              if (res.data.result.currentUser.deptid == 'ZSYH') {
                this.$router.push({
                  path: '/exhibitor/home'
                });
              } else {
                this.$router.push({
                  path: '/index'
                });
              }
            } else if (res.data.code == '22222222') {
              this.$message.error("账号不存在");
            } else if (res.data.code == '33333333') {
              this.$message.error("密码不正确");
            } else {
              this.$message.error("登录失败");
              this.$router.push({
                path: '/'
              });
            }
            this.isTCaptchaPass = false
          }.bind(this), function(error) {
            console.log(error)
          })
        }
      },
      
      closeRegisterDialog() {
        this.qyjbxxShow = false;
      }
    }

  }
</script>

<style lang="scss">
  #login {
    @import '@/common/scss/login.scss';

    /deep/.el-input {
      height: 3rem !important;
    }

    .el-input__inner {
      height: 3rem;
      line-height: 3rem;
    }

    .lgin {
      margin-top: 5rem;
    }

    // .filed {
    //   margin: 0px 1.875rem 1rem 1.875rem;
    //   // display: inline;
    // }
    .footer {
      text-align: center;
      color: $whitecolor;
      font-size: 1rem;

      * {
        text-align: center;
        color: $whitecolor;
        font-size: 1rem;
      }
    }
    a {
      text-decoration: none;
      color: #2452ff;
    }
  }
</style>import { float } from 'html2canvas/dist/types/css/property-descriptors/float';
import { borderTopRightRadius } from 'html2canvas/dist/types/css/property-descriptors/border-radius';
import { display } from 'html2canvas/dist/types/css/property-descriptors/display';




// WEBPACK FOOTER //
// src/views/exhibition/login/ch/Login.vue